import { api } from '@/api';
import { auth } from '@/auth';
import { CreateButton, EditButton } from '@/components/common';
import { Page } from '@/components/dashboard/page';
import { FilterControls } from '@/components/filter-controls';
import { createFileRoute } from '@tanstack/react-router';
import { Badge, Heading, Row, Small, Table, type BadgeProps } from 'ht-sdk/react';
import { TwoFactorBadge } from 'ht-sdk/auth/client';
import { useState } from 'react';
import { PasskeyBadge } from '@/components/passkey-badge';

export const Route = createFileRoute('/dashboard/users/')({
	component: RouteComponent,
	loader: async () => {
		const res = await api.userList({});
		return res;
	},
});

const latestTermsOfServiceVersion = 1;

const TermsBadge = ({ version }: { version: number }) => {
	let status: BadgeProps['status'], text: string;
	if (version === latestTermsOfServiceVersion) {
		status = 'success';
		text = 'Accepted';
	} else if (version == -1) {
		status = 'danger';
		text = 'Not accepted';
	} else {
		status = 'warn';
		text = 'Outdated';
	}
	return <Badge status={status}>{text}</Badge>;
};

function RouteComponent() {
	const data = Route.useLoaderData();
	if (!data.success) {
		return <div>Error loading users</div>;
	}

	const [users, setUsers] = useState(data.data);

	// const modal = useModal();

	return (
		<Page>
			<Row gap={3}>
				<Heading>Users</Heading>
				<CreateButton to="/dashboard/users/new">New User</CreateButton>
			</Row>
			<FilterControls
				items={data.data}
				onChanged={setUsers}
				getSearchableText={(s) => s.name}
				sortOptions={[
					{ key: 'name', label: 'Name', sortFn: (a, b) => a.name.localeCompare(b.name) },
					{ key: 'email', label: 'Email', sortFn: (a, b) => a.email.localeCompare(b.email) },
				]}
			/>
			{users.length === 0 && <Small>No posts found.</Small>}
			{users.length > 0 && (
				<Table
					headers={['Name', 'Email', 'Terms', 'Passkey', '2FA', 'Role', 'Actions']}
					rows={users.map((u) => [
						u.name,
						u.email,
						<TermsBadge version={u.termsOfServiceVersion} />,
						// TODO: store wether user has passkey/list of user passkeys?
						<PasskeyBadge hasPasskey={false} auth={auth} />,
						<TwoFactorBadge
							twoFaEnabled={u.isTwoFactorEnabled}
							auth={auth}
							// onClick={() => {
							// 	if (u.isTwoFactorEnabled) {
							// 		// TODO: maybe allow for disabling 2fa?
							// 		toast('2FA is already enabled!');
							// 		return;
							// 	}
							// 	modal.showModal(<TwoFactorModal auth={auth} />);
							// }}
						/>,
						<Badge status={u.role === 'admin' ? 'success' : 'neutral'}>{u.role}</Badge>,
						<Row gap={1}>
							<EditButton to="/dashboard/users/$id" params={{ id: u.id }} />
							{/* TODO: fix as={ModalButton} on inheriting other button props */}
							{/* <CopyButton as={ModalButton} onAccept={() => console.log('accept copy', u.id)} /> */}
							{/* <DeleteButton as={ModalButton} onAccept={() => console.log('accept delete', u.id)} /> */}
						</Row>,
					])}
				/>
			)}
		</Page>
	);
}
